import { render, staticRenderFns } from "./P05OneDigit.vue?vue&type=template&id=31048d2a"
import script from "./P05OneDigit.vue?vue&type=script&lang=js"
export * from "./P05OneDigit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports